"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.G2_HASH_PADDING = exports.PUBLIC_KEY_LENGTH = exports.FP_POINT_LENGTH = exports.SIGNATURE_LENGTH = exports.SECRET_KEY_LENGTH = void 0;
const SECRET_KEY_LENGTH = 32;
exports.SECRET_KEY_LENGTH = SECRET_KEY_LENGTH;
const SIGNATURE_LENGTH = 96;
exports.SIGNATURE_LENGTH = SIGNATURE_LENGTH;
const FP_POINT_LENGTH = 48;
exports.FP_POINT_LENGTH = FP_POINT_LENGTH;
const PUBLIC_KEY_LENGTH = FP_POINT_LENGTH;
exports.PUBLIC_KEY_LENGTH = PUBLIC_KEY_LENGTH;
const G2_HASH_PADDING = 16;
exports.G2_HASH_PADDING = G2_HASH_PADDING;